import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Option
 */
import { guid } from '@tencent/glue-util-helper';
import { Emitter } from '@tencent/glue-util-emitter';
import { OptionState } from '../enums';
export var Option = /*#__PURE__*/function (_Emitter) {
  _inherits(Option, _Emitter);

  var _super = _createSuper(Option);

  function Option(select, data, id, optionGroup) {
    var _this;

    _classCallCheck(this, Option);

    _this = _super.call(this);
    _this.optionGroup = null;
    _this.disposed = false;
    _this.id = id || guid();
    _this.select = select;
    _this.optionGroup = optionGroup || null;
    _this.data = data;

    _this.updateOption(data);

    _this.select.registerOption(_assertThisInitialized(_this));

    if (_this.optionGroup) {
      _this.optionGroup.registerOption(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(Option, [{
    key: "updateOption",
    value: function updateOption(data) {
      var oldLabel = this.data.label;
      this.data = _objectSpread(_objectSpread({}, data), {}, {
        disabled: !!data.disabled || this.select.isDisabled(),
        readonly: !!data.readonly || this.select.isReadonly(),
        selected: this.select.isSelected(data.value)
      });

      if (oldLabel !== data.label) {
        this.select.waitForCommit('select-label-update');
      }
    }
  }, {
    key: "setOptionState",
    value: function setOptionState(state) {
      var _this$data = this.data,
          selected = _this$data.selected,
          disabled = _this$data.disabled,
          readonly = _this$data.readonly;

      if (disabled || readonly) {
        return;
      }

      this.select.trySetSelect(this.id, state);

      if (state === OptionState.SELECTED && !selected || state === OptionState.UNSELECTED && selected) {
        this.select.setSelect(this.id, state);
      }
    }
  }, {
    key: "updateSelected",
    value: function updateSelected(selected) {
      this.data.selected = selected;
      this.stateUpdated();
    }
  }, {
    key: "getOptionState",
    value: function getOptionState() {
      if (this.data.selected) {
        return OptionState.SELECTED;
      }

      return OptionState.UNSELECTED;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getOptionIdPath",
    value: function getOptionIdPath() {
      var path = [this.id];

      if (!this.optionGroup) {
        return path;
      }

      return this.optionGroup.getOptionIdPath().concat(path);
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return false;
    }
  }, {
    key: "stateUpdated",
    value: function stateUpdated() {
      this.emit('state-updated');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      this.select.unregisterOption(this);

      if (this.optionGroup) {
        this.optionGroup.unregisterOption(this);
      }

      this.disposed = true;
    }
  }]);

  return Option;
}(Emitter);